// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"Link_linkWrapper__ID3kN"};